import React from 'react';
import { Box, Pagination, Typography } from '@mui/material';

const TaskPagination = ({ page, total, limit, onPageChange }) => {
  // 计算总页数
  const totalPages = Math.ceil(total / limit);
  
  // 处理页码变化
  const handlePageChange = (event, value) => {
    onPageChange(value);
  };
  
  // 计算当前页显示范围
  const startIndex = (page - 1) * limit + 1;
  const endIndex = Math.min(page * limit, total);
  
  // 如果总页数小于等于1，不显示分页
  if (totalPages <= 1) {
    return null;
  }
  
  return (
    <Box sx={{ 
      display: 'flex', 
      justifyContent: 'space-between', 
      alignItems: 'center',
      mt: 3, 
      mb: 2
    }}>
      <Typography variant="body2" color="text.secondary">
        显示 {startIndex}-{endIndex} 项结果，共 {total} 项
      </Typography>
      
      <Pagination
        count={totalPages}
        page={page}
        onChange={handlePageChange}
        color="primary"
        shape="circular"
        showFirstButton
        showLastButton
      />
    </Box>
  );
};

export default TaskPagination; 